export function getRotatedDimensions(width: number, height: number, rAngle: number) {
    const rad = (rAngle * Math.PI) / 180;
    return {
        width: width * Math.cos(rad) + height * Math.sin(rad),
        height: width * Math.sin(rad) + height * Math.cos(rad),
    };
}

export function scaleImagePreserveAspect(
    targetWidth: number,
    targetHeight: number,
    naturalWidth?: number,
    naturalHeight?: number
) {
    let drawWidth: number, drawHeight: number;
    const imageWidth = naturalWidth || 256;
    const imageHeight = naturalHeight || 256;
    if (imageWidth > imageHeight) {
        drawWidth = targetWidth;
        drawHeight = (imageHeight / imageWidth) * targetWidth;
    } else {
        drawWidth = (imageWidth / imageHeight) * targetHeight;
        drawHeight = targetHeight;
    }

    return {
        drawWidth: Math.ceil(drawWidth),
        drawHeight: Math.ceil(drawHeight),
    };
}

export function getBinClampedSize(width: number, height: number, rounding: 'floor' | 'ceil' = 'floor') {
    if (rounding === 'floor') {
        const log2 = Math.min(Math.log2(width), Math.log2(height));
        return Math.pow(2, Math.floor(log2));
    } else {
        const log2 = Math.max(Math.log2(width), Math.log2(height));
        return Math.pow(2, Math.ceil(log2));
    }
}

export function isIOS() {
    // return true;
    const iosQuirkPresent = function () {
        const audio = new Audio();

        audio.volume = 0.5;
        return audio.volume === 1;   // volume cannot be changed from "1" on iOS 12 and below
    };

    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    const isAppleDevice = navigator.userAgent.includes('Macintosh');
    const isTouchScreen = navigator.maxTouchPoints >= 1;   // true for iOS 13 (and hopefully beyond)

    return isIOS || (isAppleDevice && (isTouchScreen || iosQuirkPresent()));
}
